<template>
  <div class="list-multiselect">
    <div class="d-flex align-items-center justify-content-between pr-2">
      <input type="text" class="search-input form-control form-control-sm" :placeholder="searchPlaceholder" v-model="search" />
      <div class="d-flex align-items-center">
        <span class="mod-icon-select-all mb-2 mr-2" title="Select all" @click.self="selectAll" />
        <span class="mod-icon-clear-lg mb-2 mr-2" title="Deselect all" @click.self="deselectAll" />
      </div>
    </div>
    <div class="d-flex border-top mt-1">
      <div class="list-multiselect-options w-50 pr-2">
        <div v-for="(option, i) in options" :key="i">
          <div class="list-multiselect-option" @click.self="handleChange(option)" :class="[isSelected(option) ? 'list-multiselect-option-selected' : '']" v-if="isFulfillsSearch(option) && !value.includes(option[trackBy])">{{ option[label] }}</div>
        </div>
      </div>
      <div class="list-multiselect-options w-50">
        <div v-for="(option, i) in options" :key="i">
          <div class="list-multiselect-option" @click.self="handleChange(option)" :class="[isSelected(option) ? 'list-multiselect-option-selected' : '']" v-if="isFulfillsSearch(option) && value.includes(option[trackBy])">{{ option[label] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListMultiselect',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    trackBy: {
      type: String,
      default: 'id',
    },
    label: {
      type: String,
      default: 'label',
    },
    searchPlaceholder: {
      type: String,
      default: 'Search...',
    },
  },
  data() {
    return {
      search: '',
    };
  },
  methods: {
    handleChange(option) {
      let options = [];
      if (this.isSelected(option)) {
        options = this.value.filter(opt => opt !== option[this.trackBy]);
      } else {
        options = this.value;
        options.push(option[this.trackBy]);
      }
      this.$emit('change', options);
    },
    isSelected(option) {
      let hasOption = false;
      this.value.forEach(opt => {
        if (opt === option[this.trackBy]) {
          hasOption = true;
        }
      });
      return hasOption;
    },
    isFulfillsSearch(opt) {
      if (this.search) {
        if (opt[this.label].toLowerCase().includes(this.search.toLowerCase())) {
          return true;
        }
        return false;
      }
      return true;
    },
    selectAll() {
      this.$emit('change', this.options.map(opt => opt[this.trackBy]));
    },
    deselectAll() {
      this.$emit('change', []);
    },
  },
};
</script>

<style scoped>
.list-multiselect {
  width: 100%;
}

.search-input {
  width: 80%;
}

.list-multiselect-options {
  display: flex;
  flex-direction: column;
  max-height: 250px;
  overflow-x: auto;
}

.list-multiselect-option {
  text-align: left;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
  width: 100%;
}

.list-multiselect-option-selected {
  color: #2962ff;
  background-color: #eef2ff;
}
</style>



// WEBPACK FOOTER //
// src/components/ListMultiselect.vue